import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import { Dealer } from '../../../types/dealerTypes';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import styles from '../styles.module.scss';
import { TextField } from '../../Input/TextField/TextField';

const title = 'Confirm you Business Info';
const subTitle =
  'Your business information is essential to enable Upstart Auto Retail Lending. We use this information for legal and compliance purposes to enable AI-Powered Financing.';
const cardTitle = 'Business Information';
const cardDescription =
  "Confirm your dealership's legal entity name, dealership name, and dealership group if any.";

export const DealerLaunchLendingBusinessInfo: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  return (
    <DealerLaunchFormCardLayout
      form={form}
      title={title}
      subTitle={subTitle}
      cardTitle={cardTitle}
      cardSubTitle={cardDescription}
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <div className={styles.stepRow}>
        <TextField
          label="Legal Entity Name for Dealership (required)"
          tooltip="Your legal entity is the name that your dealership is registered to do business in your state."
          name="lending.businessInfo.dealershipName"
          width="md"
          form={form}
          validation={{ required: true }}
        />
        <TextField
          label="Dealer Name (required)"
          tooltip="Your dealership name is the name most commonly used to refer to your rooftop."
          name="name"
          width="md"
          form={form}
          validation={{ required: true }}
        />
      </div>
      <div className={styles.stepRow}>
        <TextField
          label="Dealership Group (optional)"
          tooltip="Your dealership group is the name most commonly used to refer to the company operating multiple rooftops, if applicable."
          name="lending.businessInfo.dealershipGroup"
          width="md"
          form={form}
          showValidation={false}
        />
      </div>
    </DealerLaunchFormCardLayout>
  );
};
